/* NAKED US : « Recently viewed ». Mémorise les fiches vues (localStorage) et remplit l'élément <recently-viewed-products>
   par le rendu de section Shopify (recherche id:…), sans dépendance à l'ancien thème. */
(function () {
  'use strict';
  var KEY = 'nk-rv';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  if (customElements.get('recently-viewed-products')) return;
  customElements.define('recently-viewed-products', class extends HTMLElement {
    connectedCallback() {
      var self = this, exclude = this.getAttribute('exclude-id'), max = parseInt(this.getAttribute('products-count') || '8', 10);
      var ids = read().filter(function (id) { return String(id) !== String(exclude); }).slice(0, max);
      if (exclude) { var list = read().filter(function (id) { return String(id) !== String(exclude); }); list.unshift(Number(exclude)); write(list.slice(0, 20)); }
      if (!ids.length || this.dataset.nkLoaded) return;
      this.dataset.nkLoaded = '1';
      var sec = this.closest('.shopify-section'); if (!sec) return;
      var sid = sec.id.replace('shopify-section-', '');
      var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
      var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search?type=product&q=' + encodeURIComponent(q) + '&section_id=' + encodeURIComponent(sid);
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'), el = d.querySelector('recently-viewed-products');
        if (el && el.innerHTML.trim()) self.innerHTML = el.innerHTML;
      }).catch(function () {});
    }
  });
})();
